/* Buck's Tallow theme JS */
(function () {
  // Mobile nav toggle
  window.btToggleNav = function () {
    var n = document.getElementById('nav');
    if (n) n.classList.toggle('open');
  };

  // Quantity stepper (works with the Shopify product form)
  window.step = function (n) {
    var i = document.getElementById('qty');
    if (!i) return;
    var v = Math.max(1, (parseInt(i.value, 10) || 1) + n);
    i.value = v;
  };

  // Product gallery: swap main image when a thumbnail is clicked
  window.setMain = function (el, src) {
    var main = document.getElementById('pdpMain');
    if (main) main.src = src;
    document.querySelectorAll('.pdp__thumbs .thumb').forEach(function (t) {
      t.classList.remove('is-active');
    });
    el.classList.add('is-active');
  };

  // ---------- Slide-out cart ----------
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sizedImage(url) {
    if (!url) return '';
    return url.replace(/(\.(?:png|jpe?g|webp|gif))(\?|$)/i, '_160x$1$2');
  }

  var drawer = {
    el: function () { return document.getElementById('cart-drawer'); },

    open: function () {
      var d = this.el();
      if (!d) return;
      this.refresh();
      d.classList.add('open');
      d.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-open');
    },

    close: function () {
      var d = this.el();
      if (!d) return;
      d.classList.remove('open');
      d.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-open');
    },

    updateCount: function (n) {
      document.querySelectorAll('.nav__count').forEach(function (e) {
        e.textContent = n;
        if (n > 0) { e.removeAttribute('hidden'); } else { e.setAttribute('hidden', ''); }
      });
    },

    render: function (cart) {
      var body = document.getElementById('cart-drawer-body');
      var foot = document.getElementById('cart-drawer-foot');
      if (!body) return;
      if (!cart.items || !cart.items.length) {
        body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
        if (foot) foot.hidden = true;
        return;
      }
      body.innerHTML = cart.items.map(function (it) {
        var variant = (it.variant_title && it.variant_title !== 'Default Title')
          ? '<div class="cart-line__variant">' + escapeHtml(it.variant_title) + '</div>' : '';
        var img = it.image ? '<img src="' + sizedImage(it.image) + '" alt="">' : '<span class="cart-line__noimg"></span>';
        return '<div class="cart-line" data-key="' + it.key + '">' +
            img +
            '<div class="cart-line__info">' +
              '<a href="' + it.url + '" class="cart-line__title">' + escapeHtml(it.product_title) + '</a>' +
              variant +
              '<div class="cart-line__qty">' +
                '<button type="button" aria-label="Decrease" onclick="btCart.change(\'' + it.key + '\',' + (it.quantity - 1) + ')">&ndash;</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button type="button" aria-label="Increase" onclick="btCart.change(\'' + it.key + '\',' + (it.quantity + 1) + ')">+</button>' +
              '</div>' +
            '</div>' +
            '<div class="cart-line__right">' +
              '<div class="cart-line__price">' + money(it.final_line_price) + '</div>' +
              '<button type="button" class="cart-line__remove" onclick="btCart.change(\'' + it.key + '\',0)">Remove</button>' +
            '</div>' +
          '</div>';
      }).join('');
      var sub = document.getElementById('cart-drawer-subtotal');
      if (sub) sub.textContent = money(cart.items_subtotal_price);
      if (foot) foot.hidden = false;
    },

    refresh: function () {
      var self = this;
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); self.updateCount(cart.item_count); })
        .catch(function () {});
    },

    change: function (key, qty) {
      var self = this;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); self.updateCount(cart.item_count); })
        .catch(function () {});
    },

    add: function (form) {
      var self = this;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { self.open(); })
        .catch(function () { form.submit(); });
    },

    init: function () {
      this.refresh();
      var pf = document.getElementById('product-form');
      if (pf) {
        pf.addEventListener('submit', function (e) {
          e.preventDefault();
          drawer.add(pf);
        });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') drawer.close();
      });
    }
  };

  window.btCart = drawer;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { drawer.init(); });
  } else {
    drawer.init();
  }
})();
